import { GroupedStageOptions, StageOption } from "./types";

export interface TransitionWithStage {
  group: string;
  stage?: {
    id: string;
    name: string;
    color: string;
    iconColor: string;
    iconName: string;
  };
}

export interface ExtendedStageOption extends StageOption {
  transitionGroup: string;
}

export interface ExtendedGroupedStageOptions extends Omit<GroupedStageOptions, "options"> {
  options: ExtendedStageOption[];
}

export function processTransitions<T extends TransitionWithStage>(
  transitions: T[],
  formatGroupNameFn?: (group: string) => string,
): ExtendedGroupedStageOptions[] {
  return transitions.reduce<ExtendedGroupedStageOptions[]>((acc, transition) => {
    if (!transition.stage) return acc;

    const groupIndex = acc.findIndex((group) => group.value === transition.group);
    const option: ExtendedStageOption = {
      label: transition.stage.name,
      value: transition.stage.id,
      color: transition.stage.color,
      iconColor: transition.stage.iconColor,
      iconName: transition.stage.iconName,
      transitionGroup: transition.group,
    };

    if (groupIndex > -1) {
      acc[groupIndex].options.push(option);
    } else {
      acc.push({
        label: formatGroupNameFn
          ? formatGroupNameFn(transition.group)
          : formatGroupName(transition.group),
        value: transition.group,
        options: [option],
      });
    }
    return acc;
  }, []);
}

export function formatGroupName(group: string) {
  return group.replace("_", " ");
}
